import { render, staticRenderFns } from "./ProductSalesPageIncludedContent.vue?vue&type=template&id=69664d86&scoped=true&"
import script from "./ProductSalesPageIncludedContent.vue?vue&type=script&lang=ts&"
export * from "./ProductSalesPageIncludedContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69664d86",
  null
  
)

export default component.exports